import { render, staticRenderFns } from "./TaskEstimationsInDetail.vue?vue&type=template&id=726d3a26&scoped=true"
import script from "./TaskEstimationsInDetail.vue?vue&type=script&lang=js"
export * from "./TaskEstimationsInDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskEstimationsInDetail.vue?vue&type=style&index=0&id=726d3a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d3a26",
  null
  
)

export default component.exports